module.exports = __webpack_public_path__ + "img/button.5b3364af.png";